import React from "react";
import { IconBrandWhatsapp, IconMail, IconChevronRight } from "@tabler/icons-react";

const WA_NUMBER = "+62 811-1991-1168";
const WA_LINK = "https://wa.me/6281119911168";
const EMAIL = "information@prasmul-eli.co";

const PolicyContact = () => {
  return (
    <section className="policy-card">
      <h2 className="policy-contact-title">Pertanyaan tentang kebijakan ini?</h2>
      <div className="policy-contact-grid">
        <a
          className="policy-contact-card"
          href={WA_LINK}
          target="_blank"
          rel="noreferrer"
        >
          <span className="policy-contact-icon pc-wa">
            <IconBrandWhatsapp size={26} />
          </span>
          <span>
            <p className="label">WhatsApp</p>
            <p className="value">{WA_NUMBER}</p>
          </span>
          <IconChevronRight className="chev" size={20} />
        </a>
        <a className="policy-contact-card" href={`mailto:${EMAIL}`}>
          <span className="policy-contact-icon pc-mail">
            <IconMail size={26} />
          </span>
          <span>
            <p className="label">Email</p>
            <p className="value">{EMAIL}</p>
          </span>
          <IconChevronRight className="chev" size={20} />
        </a>
      </div>
    </section>
  );
};

export default PolicyContact;
